const ApiDefaults = Object.freeze({
  BASIC: 'BASIC',
  DEFAULT: 'DEFAULT',
  FULL: 'FULL',
});

export {ApiDefaults};
